<template>
  <!-- 图片弹框   -->
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('navbar.seeImage')"
    :visible.sync="dialogVisible"
    top="3vh"
    width="540px"
  >
    <div>
      <div v-if="imageList.length > 0" style="width: 500px">
        <div style="text-align: center; color: #00A551; font-size: 18px">
          <span>{{ currentIndex + 1 }}</span>
          <span>/</span>
          <span>{{ imageList.length }}</span>
        </div>
        <el-carousel
          ref="carousel" height="750px" trigger="click"
          @change="handlecarousel"
        >
          <el-carousel-item v-for="item in imageList" :key="item">
            <div style="margin-left: 10px">
              <el-image
                :preview-src-list="[item]"
                :src="item"
                fit="fill"
                style="width: 100%; height: 700px"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div v-else style="width: 500px; text-align: center; height: 750px">
        <el-image style="width: 100%">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline" style="font-size: 30px" />
          </div>
        </el-image>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      imageList: [],
      currentIndex: 0
    };
  },
  methods: {
    showImageFun(arr) {
      console.log(arr, 'showImageFun');
      this.imageList = arr;
      this.dialogVisible = true;
    },
    handlecarousel(val) {
      this.currentIndex = val;
    }
  }
};
</script>
<style lang="scss" scoped></style>
